import { actionTypes } from '../constants'

export const clearAllWasClicked = () => ({
  type: actionTypes.CLEAR_ALL_WAS_CLICKED,
})

export const documentWasClickedOutsideOfOpenFilter = () => ({
  type: actionTypes.DOCUMENT_WAS_CLICKED_OUTSIDE_OF_OPEN_FILTER,
})

export const filterControlWasClicked = (esKey) => ({
  payload: {
    esKey,
  },
  type: actionTypes.FILTER_CONTROL_WAS_CLICKED,
})

export const filterSearchWasChanged = (esKey, search) => ({
  payload: {
    esKey,
    search,
  },
  type: actionTypes.FILTER_SEARCH_WAS_CHANGED,
})
